import { render, staticRenderFns } from "./BaseInput.vue?vue&type=template&id=4ff18e23&scoped=true"
import script from "./BaseInput.vue?vue&type=script&lang=js"
export * from "./BaseInput.vue?vue&type=script&lang=js"
import style0 from "./BaseInput.vue?vue&type=style&index=0&id=4ff18e23&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ff18e23",
  null
  
)

export default component.exports